import { render, staticRenderFns } from "./houseList.vue?vue&type=template&id=2833bc09&scoped=true&"
import script from "./houseList.vue?vue&type=script&lang=js&"
export * from "./houseList.vue?vue&type=script&lang=js&"
import style0 from "./houseList.vue?vue&type=style&index=0&id=2833bc09&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2833bc09",
  null
  
)

export default component.exports